// useAuth.js
import { useRef } from 'react';

function useAuth() {
 // const [isAuthenticated, setIsAuthenticated] = useState(false);
  const currentAuth = useRef(false); 
      const token = localStorage.getItem('jwtToken'); // or get it from cookies
    const expiration = localStorage.getItem('jwtExpiration');  
    if (token) {
      // Check for expiration
      const now = Date.now() / 1000; // Convert to seconds
      if (expiration && now > expiration) {
        // Token has expired, trigger logout
        currentAuth.current=false;
      }
      else
        currentAuth.current=true;
    } else {
      currentAuth.current=false;
    }
  
  return currentAuth.current;
}

export default useAuth;
